import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import About from "./pages/About";
import Experiences from "./pages/Experiences";
import DesignMyJourney from "./pages/DesignMyJourney";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Login from "./pages/Login";
import ClientDashboard from "./pages/ClientDashboard";
import ClientRegister from "./pages/ClientRegister";
import ClientLogin from "./pages/ClientLogin";
import JNTTalesPage from "./pages/JNTTalesPage";
import BlogPostPage from "./pages/BlogPostPage";
import CountryPage from "./pages/CountryPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes with Header/Footer */}
          <Route path="/" element={
            <>
              <Header />
              <main className="main-content">
                <HomePage />
              </main>
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/about" element={
            <>
              <Header />
              <main className="main-content">
                <About />
              </main>
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/experiences" element={
            <>
              <Header />
              <main className="main-content">
                <Experiences />
              </main>
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/design-journey" element={
            <>
              <Header />
              <main className="main-content">
                <DesignMyJourney />
              </main>
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Header />
              <main className="main-content">
                <Contact />
              </main>
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/jnt-tales" element={
            <>
              <Header />
              <main className="main-content">
                <JNTTalesPage />
              </main>
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/jnt-tales/country/:slug" element={
            <>
              <Header />
              <main className="main-content">
                <CountryPage />
              </main>
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/jnt-tales/:slug" element={
            <>
              <Header />
              <main className="main-content">
                <BlogPostPage />
              </main>
              <Footer />
              <WhatsAppButton />
            </>
          } />

          {/* Login Route (unified for admin and client) */}
          <Route path="/login" element={<Login />} />

          {/* Admin Routes without Header/Footer */}
          <Route path="/admin" element={<Navigate to="/login" replace />} />
          <Route path="/admin/login" element={<Navigate to="/login" replace />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />

          {/* Client Routes */}
          <Route path="/client/register" element={
            <>
              <Header />
              <main className="main-content">
                <ClientRegister />
              </main>
              <Footer />
            </>
          } />
          <Route path="/client/login" element={
            <>
              <Header />
              <main className="main-content">
                <ClientLogin />
              </main>
              <Footer />
            </>
          } />
          <Route path="/client/dashboard" element={<ClientDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
